<template>
    <div id="howDoWeDoIt" class="px-10 pt-12 tablet:pb-16 lg:px-20 xl:px-32">
        <h1 class="pb-8 text-3xl font-bold text-center text-black uppercase md:text-5xl text-heading md:pb-10">
            {{ tr('howDoWeDoIt.title') }}
        </h1>
        <div class="tablet:flex flex-row items-center justify-around">
            <div class="tablet:video-width -mx-6 md:mx-0">
                <div ref="imageContainer" class="cursor-pointer swiper-container gallery-main">
                    <div class="flex items-center swiper-wrapper">
                        <div v-for="slide of data" class="swiper-slide">
                            <img v-if="!slide.video" :src="picture(slide.image)" alt=""/>
                            <video v-else :src="video(slide.video)" controls muted loop></video>
                        </div>
                    </div>

                    <!-- <div class="swiper-pagination swiper-pagination-black"></div> -->
                    <!-- <div class="relative flex-1 flex-grow rounded shadow-lg"> -->
                    <!-- <img class="object-fill" :src="currentPicture" width="1280"> -->
                </div>
            </div>

            <div ref="descriptionContainer"
                 class="description-container flex flex-col justify-end relative w-full self-stretch mt-6 tablet:mt-0 pb-4 tablet:pb-0 tablet:ml-16">
                <!-- https://stackoverflow.com/a/42537780/8483877 CC-BY-SA 3.0 -->
                <transition @enter="animationEnter" name="description-fade">
                    <div ref="firstDescription" :key="visibleDescription.body" class="absolute top-0 left-0 w-full">
                        <h1 class="self-start pb-5 text-2xl font-extrabold text-heading tablet:text-3xl"
                            v-html="visibleDescription.title"></h1>
                        <div class="slide-description" v-html="visibleDescription.body"></div>
                    </div>
                </transition>
                <div class="flex flex-row justify-center w-full tablet:justify-end">
                    <div class="w-16 h-16 focus:outline-none swiper-prev"></div>
                    <div class="w-16 h-16 focus:outline-none swiper-next"></div>
                </div>
            </div>
        </div>
        <div class="hidden mt-12 cursor-pointer tablet:block swiper-container gallery-thumbs">
            <div class="flex items-center swiper-wrapper">
                <div v-for="slide of data" class="swiper-slide">
                    <img :src="picture(slide.image)" alt=""/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import inViewport from 'vue-in-viewport-mixin';

export default {
    name: 'HowDoWeDoIt',
    mixins: [inViewport, Translatable],
    props: {
        data: Array,
    },
    data() {
        return {
            currentTextComponentIndex: 0,
            activeIndex: 0,
        };
    },
    computed: {
        visibleDescription() {
            return this.data[this.activeIndex];
        },
    },
    watch: {
        'inViewport.now': (visible) => {
            if (visible)
                document.getElementsByTagName('video')[0].play();
        },
    },
    methods: {
        changeDescriptionHeight(height) {
            if (window.innerWidth <= 920) {  // device is a phone
                this.$refs.descriptionContainer.style.height = (height + 80) + 'px';
            }
            else {  // device is a tablet / desktop
                if (height + 80 > this.$refs.imageContainer.offsetHeight) {  // description is bigger than image
                    this.$refs.descriptionContainer.style.height = (height + 64) + 'px';
                }
                else {  // description is smaller than image
                    this.$refs.descriptionContainer.style.height = this.$refs.imageContainer.offsetHeight + 'px';
                }
            }
        },
        animationEnter(el, done) {
            this.changeDescriptionHeight(el.offsetHeight);
        },
        picture(filename) {
            return require(`../assets/img/howDoWeDoIt/${filename}`);
        },
        video(filename) {
            return require(`../assets/videos/${filename}`);
        },
        addSwiper() {
            var component = this;

            this.swiperThumbs = new Swiper('.gallery-thumbs', {
                loop: true,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slidesPerView: 8,
            });
            this.swiper = new Swiper('.gallery-main', {
                loop: true,
                navigation: {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev',
                },
                /* pagination: { */
                /*     el: '.swiper-pagination', */
                /*     dynamicBullets: true, */
                /* }, */
                thumbs: {
                    swiper: this.swiperThumbs,
                },
                on: {
                    slideChangeTransitionStart() {
                        if (this.activeIndex == 25)
                            component.activeIndex = 0;
                        else if (this.activeIndex == 0)
                            component.activeIndex = 23;
                        else
                            component.activeIndex = this.activeIndex - 1;
                    },
                    imagesReady() {
                        component.changeDescriptionHeight(component.$refs.firstDescription.offsetHeight);
                    },
                },
            });
        },
    },
    mounted() {
        this.addSwiper();
    },
};
</script>

<style scoped>
.slide-description >>> ul {
    list-style: disc;
    color: #3f91ff;
    font-size: 17px;
}

.slide-description >>> p {
    @apply text-text text-justify mb-4;
}

.slide-description >>> h1 {
    @apply text-heading font-extrabold text-xl self-start mb-1;
}

.slide-description >>> a {
    color: #3f91ff;
}

.swiper-next {
    background: url('../assets/img/icons/arrow_right_icon.svg') no-repeat center center/cover;
}

.swiper-prev {
    background: url('../assets/img/icons/arrow_left_icon.svg') no-repeat center center/cover;
}

.gallery-thumbs .swiper-slide {
    @apply p-4 opacity-50;
}

.gallery-thumbs .swiper-slide-thumb-active {
    @apply p-0 opacity-100;
}

@screen tablet {
    .tablet\:video-width {
        width: 61.8%;
        max-width: 1000px;
    }
}

.description-fade-leave-active, .description-fade-enter-active {
    transition: opacity 0.5s;
}

.description-fade-enter, .description-fade-leave-to {
    opacity: 0;
}

.description-container {
    transition: height 0.8s;
}
</style>
